let _pcdb = "";

function validateZIP(){
  if(document.getElementById("_postcode").value.length == 4){
    if(_pcdb.includes(document.getElementById("_postcode").value)){
      document.getElementById("addToCart").disabled = false;
      document.getElementById("addToCart").style.opacity = 1; 
      document.getElementById("_postcode").classList.remove("zipError");
      document.getElementById("_postcode").classList.add("zipOK");
      isVerified = true;
    }else{
      document.getElementById("addToCart").disabled = true;
      document.getElementById("addToCart").style.opacity = 0.25; 
      document.getElementById("_postcode").classList.add("zipError");
      document.getElementById("_postcode").classList.remove("zipOK");
      isVerified = false;
    }
  }else{
    alert("Please enter a valid postcode");
  }
}